//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/splm.js";
SPLM.Object = class{
    constructor( creator){
        this._d = {};
        if(creator !== undefined && creator != null && typeof creator == 'object' && creator._d !== undefined && creator._d['Class'] !== undefined)
        {
            if(creator._d.ObjectId  !== undefined) this._d['ObjectId'] = creator._d.ObjectId;
            else this._d['ObjectId'] = Object.assign({}, creator._d);
        }
        else if(creator !== undefined){
            if(creator._d !== undefined && creator._d.ObjectId  !== undefined) this._d['ObjectId'] = creator._d.ObjectId;
            else this._d['ObjectId'] = creator;
        }
    }
    get ObjectId(){return this._d['ObjectId'];}
    set ObjectId(v){this._d['ObjectId'] = v;}
    get Class(){return this._d['Class'];}
    set Class(v){this._d['Class'] = v;}
    get LocalVariable(){return this._d['LocalVariable'];}
    set LocalVariable(v){if(this._d['LocalVariable']===undefined)this._d['LocalVariable']=[]; this._d['LocalVariable'].push(v);}
    get GlobalVariable(){return this._d['GlobalVariable'];}
    set GlobalVariable(v){if(this._d['GlobalVariable']===undefined)this._d['GlobalVariable']=[]; this._d['GlobalVariable'].push(v);}
    toJSON (){return this._d;}
};

export default SPLM;